import toIntegerOrInfinity$1 from './to-integer-or-infinity.js';

var toIntegerOrInfinity = toIntegerOrInfinity$1;
var min = Math.min; // `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength

var toLength = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

export { toLength as default };
